import {useState, useEffect} from "react";
import history from "shared_history";
import queryString from "query-string";
import React from "react";
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import './styles/DateFilter.scss';
import {pastOptions, futureOptions, allOption, DATE_RANGES} from '../../hocs/withDateFilter';

// designed to work with a controller using the SchoolAdmin::DateRange#conditions method to parse the returned values
const DateFilter = ({
  useAll = true,
  useFutureOptions = true,
  customMessage = '',
  label = 'Date Range',
  dateFilter= {},
  className = '',
  multiline = false
} = {}) => {

  const dateOptions = [
    ...(useAll ? allOption : [] ),
    ...pastOptions,
    ...(useFutureOptions ? futureOptions : [])
  ];

  const {
    filter,
    from,
    to,
    setFrom,
    setTo,
    applyFilter,
    setFilter,
    clear
  } = dateFilter;

  return (
    <div className={className}>
        <label style={{display: 'inline-block', padding: '0 10px 0 0'}}>{label}</label>
        {multiline === true ? <br clear='all' /> : ''}
        <select className='date-filter no-margin input-medium' value={filter} onChange={(e) => setFilter(e.target.value)}>
          {dateOptions.map((dateOption) => <option key={dateOption[1]} value={dateOption[1]}>{dateOption[0]}</option>)}
        </select>
        {filter === 'custom' ?
          <span className='date-filter-custom-date-span'>
            <label className='date-filter-label'>
              From
            <DatePicker className="input-small date-filter-input date-filter-from" selected={from} onChange={(date) => setFrom(date)} name='search[from]' placeholder='From'/>
                        </label>

            <label className='date-filter-label'>To
            <DatePicker className="input-small date-filter-input date-filter-to" selected={to} onChange={(date) => setTo(date)} name='search[to]' placeholder='To'/>
            </label>
            <Button onClick={() => applyFilter(filter)} className='btn btn-success date-filter-submit'>Search</Button>
            {customMessage && <span className={'form-text'}>{customMessage}</span>}
          </span> : ""
        }
      <button className='btn btn-danger-inline' onClick={clear}>
        Clear Filters
      </button>
    </div>
  )
};

export default DateFilter;
